import { useContext } from 'react'

import { DashboardModalsContext } from './context'

export const useDashboardModals = () => useContext(DashboardModalsContext)
